"use client";

import React from "react";
import type { LandingHero as LandingHeroData } from "./types";

interface LandingHeroProps {
	data: LandingHeroData;
}

const renderHighlighted = (headline: string, segments: string[]) => {
	if (segments.length === 0) return headline;
	const escaped = segments
		.map((s) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"))
		.join("|");
	const regex = new RegExp(`(${escaped})`, "g");
	const parts = headline.split(regex);
	return parts.map((part, idx) =>
		segments.includes(part) ? (
			<span
				key={idx}
				className="font-bold relative inline-block bg-[linear-gradient(transparent_60%,var(--colors-automint-neon-500)_60%,var(--colors-automint-neon-500)_95%,transparent_95%)]"
			>
				{part}
			</span>
		) : (
			<React.Fragment key={idx}>{part}</React.Fragment>
		),
	);
};

export const LandingHero: React.FC<LandingHeroProps> = ({ data }) => {
	return (
		<h1 className="text-lg md:text-2xl 2xl:text-[28px] leading-tight font-light text-automint-black text-center px-2 md:px-0">
			{renderHighlighted(data.headline, data.highlightedSegments)}
		</h1>
	);
};
